export interface IStrongBoxPhysicalInventoryListingBase {
    id: number,
    count: number,
    initials: string,
    createdDate: Date,
    updatedDate: Date,
    quantityOnHand: number,
}

export interface IStrongBoxCenterPhysicalInventoryListing extends IStrongBoxPhysicalInventoryListingBase {
    centerId: number,
    centerAlias: string,
}

export interface IStrongBoxOpoPhysicalInventoryListing extends IStrongBoxPhysicalInventoryListingBase {
    opoId: number,
    opoName: string,
}

export interface IStrongBoxPhysicalInventoryContractBase {
    id?: number,
    count: number,
    initials: string,
}

export interface IStrongBoxCenterPhysicalInventoryContract extends IStrongBoxPhysicalInventoryContractBase {
    centerId: number,
}

export interface IStrongBoxOpoPhysicalInventoryContract extends IStrongBoxPhysicalInventoryContractBase {
    opoId: number,
}
